import React, { Component } from "react";
import "./ValueField.css";

class ValueFormField extends Component {


  render() {
    const {label, input: {value}} = this.props;    

    if (this.props.table === false) {
      return <div>{value}</div>
    }

    return (
      <tr className="ValueField field">
        <th>{label}</th>
        <td>{value}</td>
      </tr>
    )
  }

}

ValueFormField.defaultProps = {
  table: true
}

export default ValueFormField;